<template>
  <div class="container">
    <!-- 轮播图：主推产品 -->
    <el-row class="none">
      <el-col :span="24"
        ><div class="grid-content">
          <el-carousel
            trigger="click"
            height="400px"
            style="width: 100%; margin-top: 6px"
          >
            <el-carousel-item
              v-for="(item, index) in instruments"
              :key="index"
              style="background-color: #63626237"
            >
              <!-- 仪器图片卡片 -->
              <div class="product_center_top">
                <div class="instrument-card">
                  <img
                    :src="item.url"
                    alt="Instrument"
                    style="width: 50%; margin: 0 auto; height: auto"
                  />
                </div>
                <!-- 仪器概述卡片 -->
                <div class="instrument-card">
                  <div class="instrument-description">
                    <strong>主推产品介绍：</strong>{{ item.productIntro }}
                  </div>
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </el-col>
    </el-row>

    <!-- 中间内容:版心-->
    <div class="product_container">
      <div style="width: 88%; margin: 0 auto">
        <div class="line">Product Center</div>
      </div>

      <!-- 下拉列表 -->
      <div class="classification">
        <div class="left">
          <el-select
            v-model="queryForm.query2"
            placeholder="请选择分类"
            style="border: 1px solid #333; border-radius: 4px"
            clearable
          >
            <template v-for="item in options">
              <el-option
                :label="item.dicValueName"
                :key="item.dicValue"
                :value="item.dicValue"
                label-width="100px"
              ></el-option>
            </template>
          </el-select>

          <div class="search" @click="initProduct">
            <img
              src="../assets/image/搜索 .png"
              alt="搜索"
              style="width: 20px; height: 20px"
            />
          </div>
        </div>
        <router-link to="/DownloadCenter">
          <div class="download_center">
            <div>
              <img
                src="../assets/image/下载 (2).png"
                alt="下载中心"
                style="width: 36px; height: 36px"
              />
            </div>
            <div style="color: #fff; line-height: 40px">
              <div class="nav-link" style="width: 71px">下载中心</div>
            </div>
          </div>
        </router-link>
      </div>

      <el-container style="width: 91%; margin: 0 auto">
        <el-main>
          <el-row :gutter="30">
            <el-col :span="6" v-for="item in Items" :key="item.id">
              <div class="grid-content" style="height: 300px">
                <router-link :to="'/ProductDetail/' + item.id">
                  <div class="product_center_a">
                    <div class="a_img" style="margin: 0 auto">
                      <img
                        :src="item.url"
                        alt=""
                        style="max-width: 100%; height: auto"
                      />
                    </div>
                    <div class="a_name">
                      {{ item.productName }} {{ item.productModel }}
                    </div>
                  </div>
                </router-link>

                <div class="product_center_b">
                  <router-link
                    class="product_center_b"
                    :to="'/ProductDetail/' + item.id"
                    style="text-decoration: none"
                    >了解详情 ></router-link
                  >
                </div>
              </div>
            </el-col>
          </el-row>
        </el-main>
      </el-container>
      <!-- 分页标记 -->
      <div class="pagination">
        <el-pagination
          background
          layout="prev, pager, next"
          @currentPage="queryForm.pageNum"
          :page-size="queryForm.pageSize"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import { getDicList, getProductList } from "@/api";

export default {
  data() {
    return {
      instruments: [],
      Items: [],
      dataitem: [],
      options: [],
      value: "",
      queryForm: {
        query: "",
        query2: "",
        pageNum: 1,
        pageSize: 12,
      },
      total: 10,
      productId: "",
    };
  },

  created() {
    this.productId = this.$route.params.id;
    console.log(this.productId);
    if (this.productId != 0) {
      this.queryForm.query2 = this.productId;
    }
    this.initProduct();
    this.cotegoryOptions();
    this.initloadProduct();
  },
  watch: {
    "$route.params.id": function (newId) {
      this.productId = newId;
      // 重新加载数据或执行其他操作
      console.log(this.productId);
      if (this.productId == 0) {
        this.queryForm.query2 = null;
      } else {
        this.queryForm.query2 = this.productId;
      }
      this.initProduct();
    },
  },

  methods: {
    initProduct() {
      getProductList(this.queryForm)
        .then((res) => {
          if (res.code === "200") {
            this.total = res.data.total;
            this.Items = res.data.records;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    initloadProduct() {
      const Form = {
        query: "",
        query2: "",
        pageNum: 1,
        pageSize: 12,
      };
      getProductList(Form)
        .then((res) => {
          if (res.code === "200") {
            this.dataitem = res.data.records;
            // 获取前三条数据
            this.instruments = this.dataitem.slice(0, 3);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    cotegoryOptions() {
      getDicList("productcategory")
        .then((res) => {
          if (res.code === "200") {
            console.log(res);
            this.options = res.data;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleSizeChange(pageSize) {
      //改变当前页面个数
      this.queryForm.pageNum = 1;
      this.queryForm.pageSize = pageSize;
      this.initProduct();
    },
    handleCurrentChange(pageNum) {
      //改变当前页码
      this.queryForm.pageNum = pageNum;
      this.initProduct();
    },
  },
};
</script>

<style lang="scss" scoped>
@media (max-width: 450px) {
  .product_center_top {
    display: none;
  }
}
/* 默认样式，当浏览器宽度大于400px时 */
.el-container .el-row .grid-content {
  /* 确保每个栅格内容有适当的间距或样式 */
  margin-bottom: 20px; /* 或者其他你需要的值 */
}

/* 媒体查询，当浏览器宽度小于或等于400px时 */
@media (max-width: 450px) {
  .el-container .el-row .el-col {
    /* 设置span为24，假设总共有24个栅格单位，这样每列都会独占一行 */
    width: 100% !important; /* 覆盖Element UI的默认宽度 */
    /* 移除或覆盖其他可能干扰布局的样式 */
  }

  .el-container .el-row .grid-content {
    /* 在窄屏下，你可能需要调整某些样式，比如间距 */
    margin-bottom: 10px; /* 或者其他适合窄屏的值 */
  }
  .a_name {
    margin-top: 60px;
    font-size: 18px;
  }
  .product_center_b {
    font-size: 13px;
  }
  .classification {
    flex-direction: column; /* 改为纵向排列 */
  }
  .left {
    width: 343px !important;
  }
  .download_center {
    /* 在窄屏下，你可能想要为.download_center添加一些特定的样式 */
    width: 100%; /* 确保下载中心占据整行 */
    margin-top: 10px; /* 可选：添加一些上边距以分隔元素 */
    font-size: 16px;
    float: right !important;
    margin-right: -5px !important;
  }
  .none {
    display: none;
  }
  .product_container {
    margin-top: 82px !important;
  }
}
@media (max-width: 768px) {
  .a_img {
    height: 150px; /* 在小屏幕上减小容器高度 */
  }
}

@media (min-width: 769px) and (max-width: 1200px) {
  .a_img {
    height: 200px; /* 在中等屏幕上保持原有容器高度 */
  }
}

@media (min-width: 1201px) {
  .a_img {
    height: 250px; /* 在大屏幕上增加容器高度 */
  }
}
.pagination {
  width: 88%;
  margin: 0 auto;
  text-align: center;
  margin-bottom: 50px;
}
.left {
  display: flex;
  flex-direction: row;
  width: 300px;
  justify-content: space-between;
  align-items: center;
}
.container {
  background-color: #f8f8f8;
}
.a_img img {
  width: 100%; /* 图片宽度占满容器 */
  height: auto; /* 图片高度自动 */
  border-radius: 10px 10px 0 0; /* 图片边角圆滑，顶部有圆角，底部无 */
}

.a_name {
  padding: 10px; /* 内边距 */
  text-align: center; /* 文字居中 */
  font-weight: bold; /* 文字加粗 */
  border-radius: 0 0 10px 10px; /* 底部边角圆滑 */
  color: #333;
  margin-bottom: 10px;
}

.product_center_a:hover {
  box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.2); /* 鼠标悬停时增强阴影效果 */
  cursor: pointer;
}
.product_center_b {
  text-align: right;
  margin-top: 10px;
  margin-right: 6px;
  cursor: pointer;
  margin-bottom: 20px;
  color: black;
}
.product_center_b:hover {
  color: rgb(6, 202, 35);
}
.product_center_a {
  background-color: #ffffff; /* 背景颜色 */
  border-radius: 10px; /* 边角圆滑 */
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1); /* 添加阴影效果 */
  transition: box-shadow 0.3s ease; /* 添加阴影过渡效果 */
  margin: 10px; /* 卡片之间的间距 */
  position: relative; /* 相对定位，用于定位子元素 */
}
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
  margin-bottom: 40px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
.download_center {
  border: 1px solid #333;
  border-radius: 4px;
  display: flex;
  flex-direction: row;
  background-color: rgba(36, 132, 211, 0.836);
  width: 120px;
  // margin-left: 1037px;
  cursor: pointer;
  justify-content: space-around;
}
.download_center:hover {
  cursor: pointer;
  background-color: aqua;
  transition: 0.3s;
  color: #333;
}
.search {
  display: flex;
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中 */
  width: 50px;
  height: 29px;
  border: 1px solid #333;
  background-color: rgba(36, 132, 211, 0.836);
  border-radius: 4px;
}
.search:hover {
  cursor: pointer;
  background-color: #f00;
  transition: 0.5s;
}
.classification {
  text-align: left;
  width: 88%;
  margin: 0 auto;
  margin-top: -32px;
  display: flex;
  // flex-direction: row;
  margin-bottom: 40px;
  justify-content: space-between;
}
.line {
  border-bottom: 2px solid #ccccccf0;
  text-align: right;
  margin-top: -38px;
}
.product_container {
  margin-top: 50px;
}
.product_center_top {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: flex-start; /*确保卡片对齐*/
}
.instrument-card {
  /* 卡片样式 */
  border: 1px solid #333;
  border-radius: 30px;
  background-color: #fff; /* 背景色 */
  overflow: auto; /* 当内容超出时显示滚动条 */
  width: 40%;
  height: 350px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 25px;
  margin-bottom: 15px;
  text-align: center;
  /* 添加阴影效果 */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  transition: box-shadow 0.3s ease; /* 过渡效果 */
}
.instrument-card:hover {
  cursor: pointer;
}
.instrument-description {
  /* 概述样式 */
  padding: 30px;
  font-size: 16px;
  margin: 0 auto;
  background-color: #fff; /* 背景色 */
  border-radius: 0 0 30px 30px; /* 描述下圆角 */
}
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
  // background-color: #ccc;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 150px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}
.ProductCenter {
  width: 1920px;
  height: 2000px;
  border: aqua 1px solid;
  margin: 0 auto;
}
.mainA {
  width: 1920px;
  height: 700px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.left_1 {
  width: 760px;
  height: 640px;
  border: aqua 1px solid;
  margin-right: 50px;
}
.right_1 {
  background-color: rgb(197, 195, 193);
  width: 760px;
  height: 640px;
  border: aqua 1px solid;
}
.el-carousel__container {
  width: 760px;
  height: 640px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.el-carousel--horizontal {
  width: 760px;
  // height: 640px;
}
.carousel-image {
  width: auto; /* 图片宽度设置为 100%，占据整个 carousel 宽度 */
  height: 100%; /* 图片高度自动，保持原始比例 */
  object-fit: cover; /* 图片将被裁剪并均匀覆盖整个内容框 */
}
.el-carousel img {
  display: block;
  width: 100%;
  height: 316px;
}
.mainB {
  width: 1920px;
  height: 1000px;
  border: 1px solid red;
}
</style>
